import type { GetActionUpdateAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetActionUpdateAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetActionUpdateAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetActionUpdateAuditByIdArgs = { id: string };

export const useGetActionUpdateAuditById = createQueryHook<
  UseGetActionUpdateAuditByIdArgs,
  GetActionUpdateAuditByIdResponseRow[],
  GetActionUpdateAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getActionUpdateAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ action_update_audit: data }),
  graphqlDocument: GetActionUpdateAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
